<script setup lang="ts">

import DataExportDownloadMenu from "@/components/DataExportDownloadMenu.vue";

const emit = defineEmits<{
  (e: "export-report", format: string): void,
}>();

function handleExportReportClick(format: string) {
  emit("export-report", format);
}
</script>

<template>
  <v-card variant="outlined" class="bg-white mt-4">
    <slot name="tabs" />

    <v-row no-gutters>
      <v-col cols="12">
        <v-divider/>
        <v-row align="center" class="my-1 px-3">
          <v-spacer></v-spacer>
          <v-col cols="auto">
            <data-export-download-menu :formats="['csv', 'excel']" @click="handleExportReportClick"
                                       class="mr-2"/>
          </v-col>
        </v-row>
        <v-divider/>

        <slot />
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>

</style>
